import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from './FullWidthDropdown-style.scss';

type Props = {
    children: ReactNode;
    wrapperClass?: string;
    isVisible?: boolean;
    onShow?: () => void;
};

export const FullWidthDropdown: FC<Props> = ({ children, wrapperClass, isVisible, onShow }) => {
    if (!children) {
        return null;
    }

    return (
        <div
            className={classnames(
                wrapperClass,
                dibsCss.sassyFontBodySizeSmall,
                dibsCss.flex,
                dibsCss.textNoir,
                dibsCss.static
            )}
            onMouseEnter={onShow}
        >
            <div
                className={classnames(
                    styles.dropdown,
                    dibsCss.visible,
                    isVisible && styles.isVisible
                )}
            >
                <div
                    className={classnames(
                        styles.bodyWrapper,
                        dibsCss.left0,
                        dibsCss.absolute,
                        dibsCss.wFull,
                        dibsCss.bgWhite,
                        dibsCss.zNav,
                        isVisible
                            ? [styles.isVisible, dibsCss.opacity100, dibsCss.overflowVisible]
                            : [dibsCss.opacity0, dibsCss.overflowHidden]
                    )}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};
